import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import LocalStorageBackend from "i18next-localstorage-backend";
import Backend from "i18next-http-backend";
import resourcesToBackend from 'i18next-resources-to-backend';
import ErrorService, { EDPError } from "../services/Error.service";

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.use(resourcesToBackend((language:string, namespace:string) => import(`src/i18n/locales/${language}/${namespace}.json`)))
	.init({
		returnEmptyString: false,
		lng: 'en', // if you're using a language detector, do not define the lng option
		fallbackLng: ["en", "es", "pt"], // use en if detected lng is not available
		defaultNS: "translation",
		debug: process.env.NODE_ENV.trim() === "development",
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    backend: {
      backends: [
        LocalStorageBackend,
        resourcesToBackend((language: string, namespace: string) =>
          import(`src/i18n/locales/${language}/${namespace}.json`)
        )
      ],
      backendOptions: [
        {
          expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 días
        },
        {}
      ]
    }
  }, (err, t) => {
    ErrorService(
      new EDPError(
        err.message ?? "i18n",
        "error",
        undefined,
        err.stack
      )
    );
  });

export default i18n;
